exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-form__payment-method-item[data-v-77d308a5] {\n  padding: var(--size-md);\n  display: grid;\n  gap: var(--size-md);\n}", ""]);

// exports
